import { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { useConversionsDashboard } from 'app/components/analytics-conversions/useConversionsDashboard'
import { ConversionsDashboardShadcnComponent } from 'app/components/analytics-conversions/ConversionsDashboardShadcnComponent'
import { useUser } from 'app/utils'

// Inner component holds the data hook so its queries (conversionMetrics is
// super-only on the API) only ever fire once we've confirmed the user is a
// super user. This mirrors prod, where the route loader redirected non-super
// users before any component mounted.
function ConversionsDashboardContent() {
  const hookData = useConversionsDashboard()
  return <ConversionsDashboardShadcnComponent {...hookData} />
}

export default function ConversionsDashboard() {
  const user = useUser()
  const [searchParams, setSearchParams] = useSearchParams()

  // Set default date params client-side if missing
  useEffect(() => {
    if (!searchParams.has(`fromDate`) || !searchParams.has(`toDate`)) {
      setSearchParams(
        (previous) => {
          const next = new URLSearchParams(previous)
          if (!next.has(`fromDate`)) next.set(`fromDate`, moment().subtract(90, `days`).format(`YYYY-MM-DD`))
          if (!next.has(`toDate`)) next.set(`toDate`, moment().format(`YYYY-MM-DD`))
          if (!next.has(`selectorPreset`)) next.set(`selectorPreset`, `last_90_days`)
          return next
        },
        { replace: true },
      )
    }
  }, [])

  if (!user) return null

  // Super-user guard — must run before the data hook mounts so non-super users
  // never fire the super-only conversionMetrics query (which returns Forbidden).
  if (user.type !== `super`) {
    return <Navigate to="/" replace />
  }

  return <ConversionsDashboardContent />
}
